import { Component, Emit, Prop, Vue } from 'vue-property-decorator'
import DiagnosisConsultationModalConsultationPersonnelInfo
    from '@/modules/diagnosisModule/views/form/modals/consultation/modal-consultation-personnel-info/diagnosis-consultation-modal-consultation-personnel-info.vue'
import {
    DiagnosisConsultationFinalizationRequest,
    DiagnosisConsultationResponse,
    DiagnosisConsultationStatusEnum
} from '@/modules/diagnosisModule/services/diagnosis-consultation/diagnosis-consultation.dto'
import sessionStore from '@/session/sessionStore'
import {
    DiagnosisConsultationModalConsultationDisplayState,
    initialDiagnosisConsultationModalConsultationDisplayState
} from '@/modules/diagnosisModule/views/form/modals/consultation/modal-consultation-display/diagnosis-consultation-modal-consultation-display.model'
import { VNodeData } from 'vue/types/vnode'
import { Nullable } from '@/shared/types/app.types'

@Component({
    components: {
        DiagnosisConsultationModalConsultationPersonnelInfo
    }
})
export default class DiagnosisConsultationModalConsultationDisplay extends Vue {
    @Prop({ type: Boolean, required: true }) readonly requesterView!: boolean
    @Prop({ type: Object, required: true }) readonly consultation!: DiagnosisConsultationResponse

    @Emit('reply')
    replyConsultation(): DiagnosisConsultationFinalizationRequest {
        return {
            receiverObservations: this.state.receiverObservations!
        }
    }

    @Emit('delete')
    deleteConsultation(): number {
        return this.consultation.id
    }

    private get _isRequester(): boolean {
        return sessionStore.getUserPersonnelId() === this.consultation.requester.id
    }
    private get _isReceiver(): boolean {
        return sessionStore.getUserPersonnelId() === this.consultation.receiver.id
    }

    get personnelId(): number {
        return this.requesterView ? this.consultation.requester.id : this.consultation.receiver.id
    }
    get personnelName(): string {
        return this.requesterView ? this.consultation.requester.fullName : this.consultation.receiver.fullName
    }

    get isSolved(): boolean {
        return this.consultation.status.code === DiagnosisConsultationStatusEnum.SOLVED
    }
    get isPending(): boolean {
        return this.consultation.status.code === DiagnosisConsultationStatusEnum.PENDING
    }

    get statusClass(): VNodeData['class'] {
        return {
            'completed': this.isSolved,
            'pending': this.isPending
        }
    }
    get statusIconClass(): VNodeData['staticClass'] {
        return this.isSolved ? 'fa-check' : 'fa-clock'
    }
    get consultationClass(): VNodeData['class'] {
        let styleClass = { ...this.statusClass }
        if (!this.requesterView) {
            styleClass = {
                ...styleClass,
                'consult-card': this._isRequester || !!this.consultation.observationsReceiver,
                'consult-textarea': !this.consultation.observationsReceiver
            }
        }
        return styleClass
    }

    get observations(): Nullable<string> {
        return this.requesterView
            ? this.consultation.observationsRequester
            : this.consultation.observationsReceiver
    }
    get visibleObservations(): boolean {
        return !!this.observations
    }

    get canReplyForm(): boolean {
        return !this.requesterView && !this.consultation.observationsReceiver && this._isReceiver
    }

    get visibleObservationsRow(): boolean {
        return this.visibleObservations || this.canReplyForm
    }

    get canDelete(): boolean {
        return !this.isSolved && this._isRequester
    }

    state: DiagnosisConsultationModalConsultationDisplayState
    constructor() {
        super()
        this.state = initialDiagnosisConsultationModalConsultationDisplayState()
    }
}
